//
export default {
    name: "r-app-drawer",
    data () {
        return {
            drawer  : false,
            shows   : [],
        }
    },
    filters: {

        /**
         * 
         */
        parseUrl: ( val ) => String( "/" ).concat( String( val ) ),
    },
    methods: {

        /**
         * 
         */
        hideDrawer () {
            this.drawer =false
        },

        /**
         * 
         */
        mapShow () {
            return false
        },
        
        /**
         * 
         */
        toggleDrawer () {

        },
    },
    props: {

        /**
         * 
         */
        items: {
            type: [Array, Object],
            default: () => ({}),
        },

        /**
         *
         */
        title: String,

        /**
         * 
         */
        value: Boolean,
    },
    watch: {

        /**
         * 
         */
        drawer (val) {
            if( this.value !== val ) this.$emit( "input", this.drawer )
        },

        /**
         * 
         */
        items () {
            this.shows = Array.isArray( this.items ) ? this.items.map( this.mapShow ) : Object.values( this.items ).map( this.mapShow )
        },

        /**
         * 
         */
        value (val) {
            this.drawer = this.drawer !== val ? val : this.drawer
        },
    },
    mounted () {
        document.querySelectorAll( "main.v-content" ).item( 0 ).addEventListener( "click", this.hideDrawer )
    },
}